import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { CheckCircle, XCircle, Loader2, Bell } from 'lucide-react';
import { tournamentPush } from '../lib/api';

export default function PaymentReturnPage({ cancelled = false }) {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get('session_id');
  const [state, setState] = useState(cancelled ? 'cancelled' : 'checking');
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (cancelled || !sessionId) return;
    let active = true;
    const poll = async () => {
      try {
        const r = await tournamentPush.paymentStatus(sessionId);
        if (!active) return;
        if (r.data.payment_status === 'paid') { setState('paid'); return; }
        if (['failed', 'expired'].includes(r.data.payment_status)) { setState('failed'); return; }
        if (tries >= 8) { setState('timeout'); return; }
        setTries((t) => t + 1);
        setTimeout(poll, 2000);
      } catch {
        if (active) setState('failed');
      }
    };
    poll();
    return () => { active = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId, tries]);

  return (
    <div className="min-h-screen bg-[#0f0f0f] flex items-center justify-center p-6" data-testid="payment-return-page">
      <div className="bg-[#1a1a1a] border border-[#333] rounded-2xl p-8 max-w-sm w-full text-center">
        {state === 'checking' && (<><Loader2 className="w-12 h-12 text-[#FFB800] animate-spin mx-auto mb-4" /><h1 className="text-lg font-bold text-white mb-1">Confirmation du paiement…</h1><p className="text-sm text-[#888]">Merci de patienter quelques instants.</p></>)}
        {state === 'paid' && (<><div className="w-14 h-14 rounded-full bg-[#4ECDC4]/15 flex items-center justify-center mx-auto mb-4"><Bell className="w-7 h-7 text-[#4ECDC4]" /></div><h1 className="text-lg font-bold text-white mb-1">Notification envoyée !</h1><p className="text-sm text-[#888] mb-5">Votre paiement est confirmé et la notification a été poussée aux joueurs ciblés.</p></>)}
        {state === 'cancelled' && (<><XCircle className="w-12 h-12 text-[#666] mx-auto mb-4" /><h1 className="text-lg font-bold text-white mb-1">Paiement annulé</h1><p className="text-sm text-[#888] mb-5">Aucun montant n'a été débité.</p></>)}
        {(state === 'failed' || state === 'timeout') && (<><XCircle className="w-12 h-12 text-red-400 mx-auto mb-4" /><h1 className="text-lg font-bold text-white mb-1">{state === 'timeout' ? 'Vérification en cours' : 'Paiement non abouti'}</h1><p className="text-sm text-[#888] mb-5">{state === 'timeout' ? 'Le paiement peut prendre un peu plus de temps. Vérifiez vos notifications sous peu.' : 'Le paiement n\'a pas pu être confirmé.'}</p></>)}
        {state !== 'checking' && (
          <button onClick={() => navigate('/shop/tournaments')} className="w-full px-4 py-2.5 rounded-lg bg-[#FF6B35] hover:bg-[#E55A25] text-white font-semibold transition-colors" data-testid="payment-return-back-btn">
            Retour à mes évènements
          </button>
        )}
      </div>
    </div>
  );
}
